// Models
/**
 * OData version enumeration for conditional parameter naming
 */ export var ODataVersion = /*#__PURE__*/ function(ODataVersion) {
    /** Legacy OData (older versions) - uses @odata.etag, @odata.type, @odata.context */ ODataVersion["Legacy"] = "legacy";
    /** Modern OData (v4.01+) - uses @etag, @type, @context */ ODataVersion["Modern"] = "modern";
    return ODataVersion;
}({});
